const getLineItemBody = ({ lineItem, labels }) => {
  const lineItemFields = {
    quantity: "",
    subtitle: lineItem.subtitle || ""
  };
  switch (lineItem.type) {
    case "CONTACT_LENSES":
      const eyeSideLabel = {
        left: labels.leftEye,
        right: labels.rightEye
      }[lineItem.eyeSide || ""];
      const quantityWithEyeSide = [lineItem.quantity, eyeSideLabel].filter(Boolean).join(" | ");
      lineItemFields.quantity = quantityWithEyeSide;
      return lineItemFields;
    case "SOLUTION":
      lineItemFields.subtitle = `${lineItem.solutionType} ${lineItem.solutionVolume}${labels.unitMilli}`;
    default:
      if (lineItem.power) {
        lineItemFields.subtitle = `${labels.power}: ${lineItem.power}`;
      }
      lineItemFields.quantity = lineItem.quantity;
      return lineItemFields;
  }
};
export {
  getLineItemBody
};
//# sourceMappingURL=get-product-body.js.map
